import { Popup } from "./Popup.js";


export interface MarkerOptions {
    popup?: boolean;
    interactive?: boolean;
}

export class Marker {

    public readonly element: HTMLDivElement;
    public readonly marker: L.Marker;
    public readonly feature: L.GeoJSON = null;
    public readonly popup: Popup = null;

    private _highlightTimeout: number = 0;

    private static _colorNumber = 1;

    constructor(public readonly data: VOImmo, options: MarkerOptions = {}) {

        options = e5.ObjectUtil.extend({
            popup: true,
            interactive: true
        } as MarkerOptions, options);

        this.element = document.createElement("div");
        this.element.className = "e5-marker__container";
        this.element.innerHTML = `<div class='e5-marker__shadow'></div>
        <div class='e5-marker__pin'>
            <i class='e5-marker__icon ${data.category.marker_icon}'></i>
        </div>`;

        this.element.setAttribute("title", data.title);



        var polygonColor = "#3388ff";

        if (window.bisBase.debugMap) {
            var pin = this.element.querySelector(".e5-marker__pin") as HTMLElement;
            var ic = this.element.querySelector(".e5-marker__icon") as HTMLElement;

            // Marker._colorNumber += 1024;


            // var randomColor = "#" + Math.floor(Math.random() * 16777215).toString(16);
            // var randomColor = "#" + Math.floor(Marker._colorNumber).toString(16);
            // var randomColor = this.selectColor(Marker._colorNumber++);
            var randomColor = this.getUniqueColor(Marker._colorNumber++);

            pin.style.backgroundColor = randomColor;
            ic.style.color = randomColor;
            polygonColor = randomColor;

        }

        var icon = L.divIcon(
            {
                className: 'e5-marker',
                html: this.element,
                iconSize: [0, 0],
                iconAnchor: [0, 0]
            });

        this.marker = L.marker([data.position.lat, data.position.lng], { icon: icon, interactive: options.interactive });
        if (options.popup) {
            this.popup = new Popup(this);
        }

        if (data.polygon) {

            // stroke ?: boolean | undefined;
            // color ?: string | undefined;
            // weight ?: number | undefined;
            // opacity ?: number | undefined;
            // lineCap ?: LineCapShape | undefined;
            // lineJoin ?: LineJoinShape | undefined;
            // dashArray ?: string | number[] | undefined;
            // dashOffset ?: string | undefined;
            // fill ?: boolean | undefined;
            // fillColor ?: string | undefined;
            // fillOpacity ?: number | undefined;
            // fillRule ?: FillRule | undefined;
            // renderer ?: Renderer | undefined;
            // className ?: string | undefined;

            this.feature = L.geoJSON(data.polygon,
                {
                    interactive: false,
                    // style: {
                    //     color: '#00767C', 
                    //     fillColor: '#00767C', 
                    //     opacity: 1, 
                    //     fillOpacity: 0.5
                    // }
                    style: {
                        color: polygonColor,
                        fillColor: polygonColor,
                        stroke: true,
                        lineCap: "round",
                        lineJoin: "round",
                        fill: true,
                        weight: 3,
                        opacity: 1,
                        fillOpacity: 0.2,
                        fillRule: "evenodd"
                    }
                });
        }
    }

    private selectColor(colorNum:number, colors = 1){
        if (colors < 1) colors = 1; // defaults to one color - avoid divide by zero
        return "hsl(" + (colorNum * (360 / colors) % 360) + ",100%,50%)";
    }

    private getUniqueColor(n:number) {
        const rgb = [0, 0, 0];
      
      for (let i = 0; i < 24; i++) {
        rgb[i%3] <<= 1;
        rgb[i%3] |= n & 0x01;
        n >>= 1;
      }
      
      return '#' + rgb.reduce((a, c) => (c > 0x0f ? c.toString(16) : '0' + c.toString(16)) + a, '')
    }

    public highlight(): void {
        this.element.classList.remove("e5-marker--highlight");
        this.element.offsetWidth;
        this.element.classList.add("e5-marker--highlight");
        clearTimeout(this._highlightTimeout);
        this._highlightTimeout = setTimeout(() => {
            this.element.classList.remove("e5-marker--highlight");
        }, 2500);
    }
}